var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSharedSms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.7999V6.20006C17.5 5.07992 17.5 4.51984 17.282 4.09202C17.0903 3.71569 16.7843 3.40973 16.408 3.21799C15.9802 3 15.4201 3 14.3 3H5.7C4.5799 3 4.01984 3 3.59202 3.21799C3.21569 3.40973 2.90973 3.71569 2.71799 4.09202C2.5 4.51984 2.5 5.0799 2.5 6.2V11.8C2.5 12.9201 2.5 13.4802 2.71799 13.908C2.90973 14.2843 3.21569 14.5903 3.59202 14.782C4.01984 15 4.5799 15 5.7 15H8.125L10 18L11.875 15H14.3C15.4201 15 15.9802 15 16.408 14.782C16.7843 14.5903 17.0903 14.2843 17.282 13.908C17.5 13.4802 17.5 12.9201 17.5 11.7999Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7H13",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11H10",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharedSms);
export default __webpack_public_path__ + "static/media/ic-shared-sms.05d02549d9f5e262adab0f8a7b761e2e.svg";
export { ForwardRef as ReactComponent };